import API from "../../../../../global/api";

export const getJudgementFormData = (data) => {
    return (dispatch) => {
        dispatch(requestGetJudgementFormData());
        API.post(`divorce_judgment/get-all-data`, data).then((res) => {
            dispatch(successGetJudgementFormData(res.data))
        }).catch((err) => {
        });
    }
}

export const requestGetJudgementFormData = () => {
    return {
        type: "REQUEST_GET_JUDGEMENT_FORM_DATA"
    }
}

export const successGetJudgementFormData = (data) => {
    return {
        type: "SUCCESS_GET_JUDGEMENT_FORM_DATA",
        payload: data,
    }
}

export const errorGetJudgementFormData = (data) => {
    return {
        type: "ERROR_GET_JUDGEMENT_FORM_DATA",
        payload: data
    }
}




export const postJudgementForm = (data) => {
    return (dispatch) => {
        API.post(`divorce_judgment/start-divorce-judgment`, data).then((res) => {

            dispatch(successPostJudgementForm(data))

        }).catch((err) => {
        });
    }
}

export const requestPostJudgementForm = () => {
    return {
        type: "REQUEST_POST_JUDGEMENT_FORM"
    }
}

export const successPostJudgementForm = (data) => {
    return {
        type: "SUCCESS_POST_JUDGEMENT_FORM",
        payload: data,
    }
}

export const errorPostJudgementForm = (data) => {
    return {
        type: "ERROR_POST_JUDGEMENT_FORM",
        payload: data
    }
}



export const petitionerCheck = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/petitioner-check`, data).then((res) => {

            dispatch(successIsPetitioner(data))

        }).catch((err) => {

        });
    }
}

export const requestIsPetitioner = () => {
    return {
        type: "REQUEST_IS_PETITIONER"
    }
}

export const successIsPetitioner = (data) => {
    return {
        type: "SUCCESS_IS_PETITIONER",
        payload: data,
    }
}

export const errorIsPetitioner = (data) => {
    return {
        type: "ERROR_IS_PETITIONER",
        payload: data
    }
}


export const isMilitaryMember = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/updata-divorce-130-130a`, data).then((res) => {
            dispatch(successIsMilitaryMember(data))

        }).catch((err) => {

        });
    }
}

export const requestIsMilitaryMember = () => {
    return {
        type: "REQUEST_IS_MILITARY_MEMBER"
    }
}

export const successIsMilitaryMember = (data) => {
    return {
        type: "SUCCESS_IS_MILITARY_MEMBER",
        payload: data,
    }
}

export const errorIsMilitaryMember = (data) => {
    return {
        type: "ERROR_IS_MILITARY_MEMBER",
        payload: data
    }
}



export const numberPagesAttached = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/number-pages-attached`, data).then((res) => {
            dispatch(successNumberPagesAttached(data))
        }).catch((err) => {

        });
    }
}
export const successNumberPagesAttached = (data) => {
    return {
        type: "SUCCESS_NUMBER_PAGES_ATTACHED",
        payload: data,
    }
}




export const respondentAppears = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/respondent-appearance`, data).then((res) => {

            dispatch(successRespondentAppears(data))

        }).catch((err) => {

        })
    }
}

export const requestRespondentAppears = () => {
    return {
        type: "REQUEST_RESPONDENT_APPEARS"
    }
}
export const successRespondentAppears = (data) => {
    return {
        type: "SUCCESS_RESPONDENT_APPEARS",
        payload: data
    }
}
export const errorRespondentAppears = (data) => {
    return {
        type: "ERROR_RESPONDENT_APPEARS",
        payload: data
    }
}


export const finalDeclarationsWaive = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/update-divorce-judgment-170`, data).then((res) => {
            dispatch(successFinalDeclarationsWaive(data))
        }).catch((err) => {
        });
    }
}

export const requestFinalDeclarationsWaive = () => {
    return {
        type: "REQUEST_FINAL_DECLARATIONS"
    }
}

export const successFinalDeclarationsWaive = (data) => {
    return {
        type: "SUCCESS_FINAL_DECLARATIONS",
        payload: data,
    }
}

export const errorFinalDeclarationsWaive = (data) => {
    return {
        type: "ERROR_FINAL_DECLARATIONS",
        payload: data
    }
}




export const amendPetition = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/update-amend-petition`, data).then((res) => {
            dispatch(successAmendPetition(data))
        }).catch((err) => {
        });
    }
}

export const requestAmendPetition = () => {
    return {
        type: "REQUEST_AMEND_PETITION"
    }
}

export const successAmendPetition = (data) => {
    return {
        type: "SUCCESS_AMEND_PETITION",
        payload: data,
    }
}

export const errorAmendPetition = (data) => {
    return {
        type: "ERROR_AMEND_PETITION",
        payload: data
    }
}



export const eventHappened = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment//update-event-happened`, data).then((res) => {
            dispatch(successEventHappened(data))
        }).catch((err) => {
        });
    }
}

export const requestEventHappened = () => {
    return {
        type: "REQUEST_EVENT_HAPPENED"
    }
}

export const successEventHappened = (data) => {
    return {
        type: "SUCCESS_EVENT_HAPPENED",
        payload: data,
    }
}

export const errorEventHappened = (data) => {
    return {
        type: "ERROR_EVENT_HAPPENED",
        payload: data
    }
}



export const filingCompeleting = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/update-filling-option`, data).then((res) => {
            dispatch(successFilingCompeleting(data))
        }).catch((err) => {
        });
    }
}

export const requestFilingCompeleting = () => {
    return {
        type: "REQUEST_FILING_COMPELETING"
    }
}

export const successFilingCompeleting = (data) => {
    return {
        type: "SUCCESS_FILING_COMPELETING",
        payload: data,
    }
}

export const errorFilingCompeleting = (data) => {
    return {
        type: "ERROR_FILING_COMPELETING",
        payload: data
    }
}

export const dissolvingMarriage = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/status-divorce`, data).then((res) => {
            dispatch(successDissolvingMarriage(data))
        }).catch((err) => {
        });
    }
}

export const requestDissolvingMarriage = () => {
    return {
        type: "REQUEST_DISSOLVING_MARRIAGE"
    }
}

export const successDissolvingMarriage = (data) => {
    return {
        type: "SUCCESS_DISSOLVING_MARRIAGE",
        payload: data,
    }
}

export const errorDissolvingMarriage = (data) => {
    return {
        type: "ERROR_DISSOLVING_MARRIAGE",
        payload: data
    }
}


export const haveMinorChild = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/minor-children-no`, data).then((res) => {
            dispatch(successHaveMinorChild(data))
        }).catch((err) => {
        });
    }
}

export const requestHaveMinorChild = () => {
    return {
        type: "REQUEST_HAVE_MINOR_CHILD"
    }
}

export const successHaveMinorChild = (data) => {
    return {
        type: "SUCCESS_HAVE_MINOR_CHILD",
        payload: data,
    }
}

export const errorHaveMinorChild = (data) => {
    return {
        type: "ERROR_HAVE_MINOR_CHILD",
        payload: data
    }
}



export const haveSpousalSupport = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/spousal-support`, data).then((res) => {
            dispatch(successHaveSpousalSupport(data))
        }).catch((err) => {
        });
    }
}

export const requestHaveSpousalSupport = () => {
    return {
        type: "REQUEST_HAVE_SPOUSAL_SUPPORT"
    }
}

export const successHaveSpousalSupport = (data) => {
    return {
        type: "SUCCESS_HAVE_SPOUSAL_SUPPORT",
        payload: data,
    }
}

export const errorHaveSpousalSupport = (data) => {
    return {
        type: "ERROR_HAVE_SPOUSAL_SUPPORT",
        payload: data
    }
}



export const changeFormerName = (data) => {
    return (dispatch) => {
        API.put(`divorce_judgment/former-name`, data).then((res) => {
            dispatch(successChangeFormerName(data))
        }).catch((err) => {
        });
    }
}

export const requestChangeFormerName = () => {
    return {
        type: "REQUEST_CHANGE_FORMER_NAME"
    }
}

export const successChangeFormerName = (data) => {
    return {
        type: "SUCCESS_CHANGE_FORMER_NAME",
        payload: data,
    }
}

export const errorChangeFormerName = (data) => {
    return {
        type: "ERROR_CHANGE_FORMER_NAME",
        payload: data
    }
}

